"use client";

import WebLayout from "@/components/layout/web/WebLayout";
import CPageHeaderSkeleton from "@/components/main/CPageHeaderSkeleton";
import { Card, Skeleton } from "@mantine/core";

const loading = () => {
  return (
    <>
      <CPageHeaderSkeleton />
      <section>
        <div className=" flex max-w-[900px] mx-auto py-10">
          <Card withBorder padding={"xl"} className="w-full">
            <div className=" md:flex md:space-x-3">
              <div className="w-full mt-3">
                <Skeleton height={44} className="max-w-[419px]" />
              </div>
              <div className="w-full mt-3">
                <Skeleton height={44} className="max-w-[419px]" />
              </div>
            </div>
            <div className="mt-3 w-full">
              <Skeleton height={44} className="max-w-[850px]" />
            </div>
            <div className="mt-3 w-full">
              <Skeleton height={108} className="max-w-[850px]" />
            </div>
            <div className="flex justify-end mt-5">
              <Skeleton height={36} width={94} />
            </div>
            <div className="h-[1px] bg-greyOpacity mt-8"></div>
            <div className="flex flex-col md:flex-row items-center justify-center mt-6">
              <div className="mt-3 md:mt-0">
                <Skeleton height={22} width={148} mb={2} />
                <Skeleton height={22} width={148} />
              </div>
              <div className="h-[80px] w-[1px] bg-greyOpacity mx-10 hidden md:block"></div>
              <div className="mt-3 md:mt-0">
                <div
                  className={
                    "m-0 no-underline transition-all duration-300 text-textGrey hover:text-primary"
                  }
                >
                  <Skeleton height={24} width={293} />
                </div>
              </div>
              <div className="h-[80px] w-[1px] bg-greyOpacity mx-10 hidden md:block"></div>
              <div className="mt-3 md:mt-0">
                <Skeleton height={22} width={185} mb={2} />
                <Skeleton height={22} width={185} />
              </div>
            </div>
          </Card>
        </div>
      </section>
    </>
  );
};

export default WebLayout(loading);
